/* INOAR México — Theme JS v2.0 */

// Nav scroll effect
window.addEventListener('scroll', () => {
  const nav = document.getElementById('inoar-nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
});

// Mobile menu
function inoarToggleMenu() {
  const menu = document.getElementById('inoar-mobile-menu');
  const h1 = document.getElementById('hb1');
  const h2 = document.getElementById('hb2');
  const h3 = document.getElementById('hb3');
  const isOpen = menu.classList.toggle('open');
  if (h1) h1.style.transform = isOpen ? 'rotate(45deg) translate(4px,4px)' : '';
  if (h2) h2.style.opacity = isOpen ? '0' : '';
  if (h3) h3.style.transform = isOpen ? 'rotate(-45deg) translate(4px,-4px)' : '';
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

// FAQ accordion
function inoarToggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  item.closest('.faq-list').querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// Product filter
function inoarFilterProducts(cat, btn) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('[data-product-card]').forEach(card => {
    const show = cat === 'all' || card.dataset.cat === cat;
    card.style.display = show ? 'block' : 'none';
    if (show) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(10px)';
      requestAnimationFrame(() => {
        card.style.transition = 'opacity 0.3s, transform 0.3s';
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      });
    }
  });
}

// Smooth scroll to anchor
function inoarScrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Newsletter form
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('inoar-newsletter-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button');
      if (input && input.value) {
        btn.textContent = '¡Suscrito! ✓';
        btn.style.background = '#2ecc71';
        input.value = '';
        setTimeout(() => { btn.textContent = 'Suscribirme →'; btn.style.background = ''; }, 3000);
      }
    });
  }
});

/* ── Galería de producto ── */
function inoarSetMainImg(src, thumb) {
  const main = document.getElementById('gallery-main-img');
  if (main) main.src = src;
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}

/* ── Tabs de producto ── */
function inoarTab(key, btn) {
  document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
  btn.classList.add('active');
  const content = document.getElementById('tab-' + key);
  if (content) content.classList.add('active');
}

/* ── Variantes ── */
function inoarVariant(btn) {
  btn.closest('.variant-options').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}

/* ── Cantidad ── */
function inoarQty(delta) {
  const input = document.getElementById('qty-input');
  if (!input) return;
  let val = parseInt(input.value) + delta;
  if (val < 1) val = 1;
  input.value = val;
}

/* ── Filtro colección ── */
function inoarCollectionFilter(cat, btn) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.pcard-wrap').forEach(card => {
    const show = cat === 'all' || card.dataset.cat === cat;
    card.style.display = show ? 'flex' : 'none';
  });
  const visible = document.querySelectorAll('.pcard-wrap[style*="flex"]').length;
  const counter = document.getElementById('product-count');
  if (counter) counter.textContent = visible + ' productos';
}

/* ── Sort colección (visual) ── */
function inoarSort(select) {
  const grid = document.getElementById('collection-grid');
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll('.pcard-wrap'));
  cards.sort((a, b) => {
    const pa = parseFloat(a.dataset.price || 0);
    const pb = parseFloat(b.dataset.price || 0);
    if (select.value === 'price-asc') return pa - pb;
    if (select.value === 'price-desc') return pb - pa;
    if (select.value === 'name-asc') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
    return 0;
  });
  cards.forEach(c => grid.appendChild(c));
}
